import { Component, Prop, h } from '@stencil/core';
import { serviceNumber } from '../../utils/ttarp';
import phone from '../../assets/header/phone_icon.svg';

@Component({
  tag: 'customer-contact',
  styleUrl: 'customer-contact.scss',
})
export class CustomerContact {
  @Prop() contactFlavor: 'default' | 'simple' = 'default';
  @Prop() serviceNumber: string = serviceNumber;

  render() {
    if (this.contactFlavor == 'simple') {
      return (
        <div class="ghf-customerContact--simple">
          <div>
            <a class="img" title="Customer Support Headset" href={`tel:${this.serviceNumber}`} />
            <span class="ghf-customerContact-helpText">Help</span>
          </div>
          <div>
            <span class="ghf-customerContact-text">Talk To A Real Person</span>
            <a class="ghf-customerContact-storeText" href={`tel:${this.serviceNumber}`}>
              {this.serviceNumber}
            </a>
          </div>
        </div>
      );
    }
    return (
      <a class="ghf-customerContact--default ghf-customerContact-link" href={`tel:${this.serviceNumber}`}>
        <img class="ghf-customerContact-icon" src={phone} alt="phone icon" />
        <span class="ghf-customerContact-link--mobile">Help</span>
        <span class="ghf-customerContact-link--desktop">{this.serviceNumber}</span>
      </a>
    );
  }
}
